import ZoomOutIcon from '@atlaskit/icon/core/zoom-out';
import * as React from 'react';

export function SvgZoomOut() {
  return <ZoomOutIcon label="" testId="ads-refreshed-icon" />;
}
